import { EpimsBaseEntityDto } from './epim-base.dto';
export class ObligationBeneficiaryDto extends EpimsBaseEntityDto {

 LandTitleId: string;
 AddressBookId: string;
 SubscriptionUserId: string;
 MappedBy: string;
 DateMapped: Date;
 BeneficiaryType: string;

}
